const CheckIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" className={className} {...props}>
      <path
        d="M17.1675 6.48458C17.8156 5.83847 18.866 5.83847 19.5141 6.48458L19.628 6.61012C20.1593 7.25985 20.1216 8.2183 19.5141 8.82402L10.795 17.5156C10.147 18.1615 9.09652 18.1614 8.44845 17.5156L4.48601 13.5652C3.83794 12.9191 3.83805 11.8719 4.48601 11.2258C5.02071 10.6927 5.82733 10.6003 6.45758 10.9454L6.58167 11.0205L6.59821 11.0315L6.68829 11.0975C6.70305 11.1083 6.71717 11.1207 6.73057 11.1332L6.73608 11.1387L6.79767 11.1928L6.80686 11.201L6.82248 11.2157L9.6222 14.0069L17.1675 6.48458Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckIcon;
